// extracted by mini-css-extract-plugin
export var addButton = "_bw-0";
export var border = "_bw-8";
export var check = "_bw-h";
export var danger = "_bw-6";
export var dropdownContainer = "_bw-1";
export var editModalBody = "_bw-j";
export var footerContainer = "_bw-i";
export var fullWidth = "_bw-a";
export var hide = "_bw-9";
export var icon = "_bw-3";
export var input = "_bw-7";
export var inputFlex = "_bw-b";
export var inputWrapper = "_bw-c";
export var manualFocus = "_bw-5";
export var optionButton = "_bw-4";
export var pillWrapper = "_bw-e";
export var pointer = "_bw-2";
export var showOverflow = "_bw-f";
export var tagsFlex = "_bw-d";
export var xButton = "_bw-g";